<template>
  <v-dialog
    v-model="show"
    persistent
  >
    <!-- ダイアログ外クリックで戻る場合 -->
    <!-- @click:outside="handleClickCancel" -->
    <v-card>

      <v-container v-if="optionForm">
        <v-row justify="center">
          <v-col cols="12">
            <h1>{{$t("message.admin.sendmail.title.list")}}</h1>
          </v-col>
        </v-row>

        <template v-if="view.list.length > 0">

          <v-row justify="center">
            <v-col cols="12" class="pt-2 py-0 pt-md-0">
                <div class="text-right ma-0 py-0 list-count">{{$t("message.admin.sendmail.desc.list.listCount1")}}：{{ view.list.length | addComma  }}{{$t("message.admin.sendmail.desc.list.listCount2")}}</div>
            </v-col>
          </v-row>

          <v-row justify="center">
            <v-col cols="12">
              <v-data-table
                item-key="accountId"
                :headers="headers"
                hide-default-header
                :items="view.list"
                locale="jp"
                loading-text="読込中"
                no-data-text="データがありません。"
                hide-default-footer
                mobile-breakpoint=0
                class="elevation-1"
                disable-pagination
                height="60vh"
              >
                <template v-slot:[`item.groupName`]="{ item }">
                  {{ item.groupLargeNameJp }}＞{{ item.groupSmallNameJp }}
                </template>
              </v-data-table>

              <!-- <div class="text-center pt-2">
                <v-pagination color="#0F9956" circle v-model="search.paging.page" :length="search.paging.pageCount"></v-pagination>
              </div> -->
            </v-col>
          </v-row>

        </template>
        <template v-else-if="view.list.length === 0">

          <v-row justify="center" height="600">
            <v-col cols="12" class="pt-0">
              <div>
                {{$t("message.admin.sendmail.desc.list.noData")}}
              </div>
            </v-col>
          </v-row>
        </template>

      </v-container>
      <v-card-actions>
        <v-spacer></v-spacer>
        <mp-button min class="btn-half-wide" @click="handleClickCancel">{{$t("message.admin.sendmail.button.back", "ja")}}</mp-button>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import i18n from '@/message'
import constantValue from '@/constantValue'
import MpButton from '@/components/item/MpButton.vue'

import { AdminSendMail } from '@/api'

export default {
  components: {
    MpButton
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    optionForm: {
      type: Object,
      default: null
    }
  },
  data: () => ({
    view: {
      list: []
    },
    search: {
      // paging: {
      //   page: 1,
      //   pageCount: 5,
      //   itemsPerPage: 50
      // }
    }
  }),
  computed: {
    headers () {
      return [
        { text: i18n.t('message.admin.sendmail.label.list.group'), value: 'groupName', sortable: false, width: 300 },
        { text: i18n.t('message.admin.sendmail.label.list.companyName'), value: 'companyName', sortable: false, width: 300 },
        { text: i18n.t('message.admin.sendmail.label.list.mailAddress'), value: 'mailAddress', sortable: false },
        { text: i18n.t('message.admin.sendmail.label.list.name'), value: 'name', sortable: false, width: 300 }
      ]
    }
  },
  methods: {
    async goSearch (params) {
      // サーバから取得
      await AdminSendMail.search(params)
        .then((data) => {
          this.view.list = data
        })
        .catch(error => {
          this.$parent.view.errors = error.messages
          this.handleClickCancel()
        })
    },
    groupLargeName () {
      for (const g of this.group) {
        if (g.groupLargeId === this.optionForm.groupLargeId) {
          return g.groupLargeName.ja
        }
      }
      return ''
    },
    groupSmallName () {
      for (const g of this.group) {
        if (g.groupLargeId === this.optionForm.groupLargeId) {
          for (const sg of g.groupSmallList) {
            if (sg.groupSmallId === this.optionForm.groupSmallId) {
              return sg.groupSmallName.ja
            }
          }
        }
      }
      return ''
    },
    companyName () {
      if (this.optionForm.companyId === constantValue.otherCompanyId) {
        return { base: this.optionForm.companyName, kana: this.optionForm.companyNameKana }
      }
      for (const c of this.company) {
        if (c.companyId === this.optionForm.companyId) {
          return { base: c.companyName }
        }
      }
      return {}
    },
    // キャンセルクリック時
    handleClickCancel (ev) {
      // 親のclickCancelを呼び出し
      this.$emit('clickCancel', ev)
    }
  },

  watch: {
    show () {
      if (this.show) {
        this.goSearch(this.optionForm)
      }
    }
  }
}
</script>

<style scoped>
.confirm-line {
  border-bottom: solid 1px rgba(0, 0, 0, 0.33);
}
.btn-half-wide {
  width: 45%;
}
</style>
